import React from "react";
import { fmtKop } from "../../utils/format";
import styles from "./PlanFactTable.module.css";

// rows: [{ [labelKey], plan_kop, fact_kop, diff_kop, [futureKey] }]
export default function PlanFactTable({ rows, labelKey, labelTitle, futureKey }) {
  if (!rows || rows.length === 0) {
    return <div className={styles.empty}>Нет данных.</div>;
  }
  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{labelTitle}</th>
            <th className={styles.num}>План</th>
            <th className={styles.num}>Факт</th>
            <th className={styles.num}>Разница</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => {
            const future = futureKey ? r[futureKey] : r.status === "future";
            const diff = r.diff_kop;
            const diffClass = future ? "" : diff > 0 ? styles.pos : diff < 0 ? styles.neg : "";
            return (
              <tr key={i} className={future ? styles.future : r.status === "current" ? styles.current : ""}>
                <td className={styles.label}>{r[labelKey]}</td>
                <td className={styles.num}>{fmtKop(r.plan_kop, { short: true })}</td>
                <td className={styles.num}>{future ? "—" : fmtKop(r.fact_kop, { short: true })}</td>
                <td className={`${styles.num} ${diffClass}`}>
                  {future ? "—" : `${diff > 0 ? "+" : ""}${fmtKop(diff, { short: true })}`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
